"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Body1Strong", {
    enumerable: true,
    get: function() {
        return Body1Strong;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _createPreset = require("../createPreset");
const _useBody1StrongStylesstyles = require("./useBody1StrongStyles.styles");
const Body1Strong = (0, _createPreset.createPreset)({
    useStyles: _useBody1StrongStylesstyles.useBody1StrongStyles,
    className: _useBody1StrongStylesstyles.body1StrongClassNames.root,
    displayName: 'Body1Strong'
});
